import { createStore, applyMiddleware } from 'redux'
import history from './history'
import { routerMiddleware } from 'react-router-redux'
import reduxThunk from 'redux-thunk'
// import { createLogger } from 'redux-logger'
// import { composeWithDevTools } from 'redux-devtools-extension'
import rootReducer from '../reducers'

// const loggerMiddleware = createLogger()

const configureStore = preloadedState => {
  return createStore(
    rootReducer,
    preloadedState,
    // composeWithDevTools(
    applyMiddleware(
      reduxThunk,
      routerMiddleware(history)
      // loggerMiddleware
    )
  )
  // )
}

export default configureStore



// WEBPACK FOOTER //
// ./src/store/configureStore.js